import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AuthRoutingModule } from './auth-routing.module';
import { InfoDialogComponent } from './info-dialog/info-dialog.component';
import {DialogModule} from 'primeng/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { PageLoginImgComponent } from './page-login-img/page-login-img.component';
import { SharedModule } from 'src/app/shared/shared/shared.module';
@NgModule({
    declarations: [
    InfoDialogComponent,
    PageLoginImgComponent
  ],
    imports: [
        CommonModule,
        DialogModule,
        TranslateModule,
        ButtonModule,
        AuthRoutingModule,
        SharedModule
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: [
    InfoDialogComponent,
    CommonModule,
    ButtonModule,
    TranslateModule,
    PageLoginImgComponent,
  ]
})
export class AuthModule { }
